<template>
  <section class="platforms-section bg-lighter py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center px-5 platforms-heading">
          Artwork licensed on Art Grab is perfect for use on platforms like:
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12 logo-wrapper">
          <div class="platforms-logo">
            <img src="/img/logos/spotify.png" alt="Spotify">
          </div>
          <div class="platforms-logo">
            <img src="/img/logos/apple-music.png" alt="Apple Music">
          </div>
          <div class="platforms-logo">
            <img src="/img/logos/soundcloud.png" alt="SoundCloud">
          </div>
          <div class="platforms-logo">
            <img src="/img/logos/bandcamp.png" alt="Bandcamp">
          </div>
          <div class="platforms-logo">
            <img src="/img/logos/distrokid.png" alt="DistroKid">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "platforms",
};
</script>

<style scoped lang="scss">
.platforms-section {
  .platforms-heading {
    color: #8898aa;
  }

  .logo-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 0 30px;

    .platforms-logo {
      padding: 8px 2px;

      img {
        max-height: 36px;
        max-width: 200px;
      }
    }
  }
}

@media (max-width: 991.98px) {
  
}
</style>
